import { UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalMutation } from 'src/Libs/api'
import { grantInstallerAccess, GrantInstallerAccessData } from '../api/grant-installer-access.api'

interface UseGrantInstallerAccessParams {
  onSuccess: () => void
  onError: () => void
}

/**
 * Hook to grant a Flow installer (individual Hager user) access to an installation.
 */
export const useGrantInstallerAccess = ({
  onSuccess,
  onError,
}: UseGrantInstallerAccessParams): UseMutationResult<void | null, Error, GrantInstallerAccessData> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation<void, Error, GrantInstallerAccessData>({
    mutationFn: data => grantInstallerAccess(data, authFetch),
    onSuccess,
    onError,
  })
}
